import type { Locale } from '@seek/melways-sites';

export const getPrivacyUrl = (locale: Locale) => {
  const urls: { [key: string]: string } = {
    'en-PH': 'https://ph.employer.seek.com/privacy',
    'en-SG': 'https://sg.employer.seek.com/privacy',
    'en-MY': 'https://my.employer.seek.com/privacy',
    'en-ID': 'https://id.employer.seek.com/privacy',
    'id-ID': 'https://id.employer.seek.com/id/privacy',
    'en-TH': 'https://th.employer.seek.com/privacy',
    'th-TH': 'https://th.employer.seek.com/th/privacy',
    'en-HK': 'https://hk.employer.seek.com/privacy',
    'en-AU': 'https://www.seek.com.au/privacy/',
    'en-NZ': 'https://www.seek.co.nz/privacy/',
  };
  return urls[locale];
};

export const getPrivacyLink = (locale: Locale) => {
  switch (locale) {
    case 'en-MY':
    case 'en-SG':
    case 'en-ID':
    case 'en-PH':
    case 'en-HK':
    case 'en-TH':
      return 'privacy policy';
    case 'id-ID':
      return 'kebijakan privasi';
    case 'th-TH':
      return 'นโยบายความเป็นส่วนตัว';
    default:
      return 'SEEK Privacy Statement';
  }
};
